import { css } from 'lit';
import { fsDesignToken } from '../../core/style-util.js';

export const style = css`
  .grv-checkbox::part(fs-form-field) {
    align-items: unset;
    flex-wrap: nowrap;
  }

  .grv-checkbox::part(fs-field-label) {
    font-size: ${fsDesignToken('fsFontSizeMedium1')};
    font-weight: ${fsDesignToken('fsFontWeightRegular')};
    line-height: ${fsDesignToken('fsFontLineHeightNormal')};
    padding-left: 8px;
  }
`;
